import { FieldDefinition } from "./fieldDefinitions";

export interface SpecialtyDto {
  specialtyId: number;
  specialtyDescr: string;
  specialtyRemarks?: string;
}

export const specialtyKeyId = "specialtyId" as const;

// Ορίζουμε τον τύπο των πεδίων για τη φόρμα
export const specialtyFields: FieldDefinition[] = [
  {
    name: "specialtyDescr",
    label: "Περιγραφή Ειδικότητας",
    type: "text",
    required: true,
  },
  {
    name: "specialtyRemarks",
    label: "Παρατηρήσεις",
    type: "text",
    required: false,
  },
] as const;

export const specialtyFilters = specialtyFields.filter((f) =>
  ["specialtyDescr", "specialtyRemarks"].includes(f.name),
);

export const specialtyFormData: string[] = [
  "specialtyDescr",
  "specialtyRemarks",
];
